export default __webpack_public_path__ + "static/media/col-top.d81a7ef4.png";